import clsx from "clsx";
import { Link } from "./link";

export function Text({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"p">) {
  return (
    <p
      data-slot="text"
      {...props}
      className={clsx(
        className,
        "text-base/6 text-gallery-600 sm:text-sm/6 dark:text-gallery-400",
      )}
    />
  );
}

export function TextLink({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Link>) {
  return (
    <Link
      {...props}
      className={clsx(
        className,
        "text-gallery-900 underline decoration-gallery-900/30 underline-offset-2 data-[hover]:decoration-gallery-900 dark:text-white dark:decoration-white/30 dark:data-[hover]:decoration-white transition-colors",
      )}
    />
  );
}

export function Strong({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"strong">) {
  return (
    <strong
      {...props}
      className={clsx(className, "font-medium text-gallery-900 dark:text-white")}
    />
  );
}

export function Code({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"code">) {
  return (
    <code
      {...props}
      className={clsx(
        className,
        "rounded border border-gallery-200 bg-gallery-50 px-1.5 py-0.5 text-sm font-mono text-gallery-800 dark:border-white/20 dark:bg-white/5 dark:text-white",
      )}
    />
  );
}
